module.exports = __webpack_public_path__ + "img/91.10.pH.c3255662.png";